<template>
  <v-card class="d-flex-row justify-space-around align-center pa-4 ma-0" elevation="0">
    <div style="width: 100%">
      <span class="card-title">
        <v-icon v-if="arrow" class="pr-2" @click="voltar" color="#BC0000" size="26">mdi-arrow-left</v-icon>
        <b :style="!arrow ? 'margin-left: 15px' : ''"> {{ title }}</b>
      </span>
      <v-card-text class="card-text">{{ text }} </v-card-text>
    </div>

    <div
      class="d-flex ma-0 pa-0 px-12"
      style="justify-content: flex-end"
      v-if="haveAction"
    >
      <v-btn
        class="header-button hidden-sm-and-down"
        color="#2D3038"
        elevation="2"
        @click="action"
        >Novo revendedor</v-btn>



      <v-btn
        fab
        tile
        small
        class="header-button hidden-md-and-up"
        color="#2D3038"
        elevation="2"
        @click="action"
      >
        <v-icon>mdi-plus</v-icon></v-btn
      >

      <v-btn
        class="header-button hidden-sm-and-down"
        v-if="haveAction"
        color="normalred"
        elevation="0"
        @click="action2"
        >Importar revendedores</v-btn
      >

      <v-btn
        fab
        tile
        small
        class="header-button hidden-md-and-up"
        color="normalred"
        elevation="2"
        @click="action2"
      >
        <v-icon>mdi-cloud-upload</v-icon></v-btn
      >

      <v-btn
          class="header-button hidden-sm-and-down"
          color="primary"
          elevation="2"
          @click="action3"
      >Copiar link de cadastro</v-btn
      >
    </div>
  </v-card>
</template>

<style scoped>
.card-title {
  font-family: Roboto;
  font-size: 1.5rem !important;
}
.card-text {
  display: flex;
  justify-content: space-between;

  font-family: Roboto;
  font-size: 1rem;
  font-weight: 300;
  line-height: 30px;

  width: 70%;

  color: #9c9c9c;
}
</style>

<script>
export default {
  name: "HeaderCard",

  props: {
    arrow: Boolean,
    title: String,
    text: String,
    actionTitle: String,
    haveAction: Boolean,
  },

  methods: {
    action() {
      this.$emit("action");
    },

    action2() {
      this.$emit("action2");
    },
    action3() {
      this.$emit("action3");
    },

    voltar() {
      this.$emit("voltar");
    },
  },
};
</script>
